// extracted by mini-css-extract-plugin
export default {"container":"_styles_container__RxV2H","price_list_wrap":"_styles_price_list_wrap__FPR-A","title":"_styles_title__hzh6C","price_list":"_styles_price_list__ZHSVR"};